var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "flex gap-2 items-center text-primary text-xl font-medium",
        },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [
            _vm._v(" mdi-note-text-outline "),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("order.title")))]),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "py-5 px-7 mt-6 rounded-lg", attrs: { flat: "" } },
        [
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.autoTransferBank"),
              state: _vm.state.createOrder,
            },
            on: {
              input: function ($event) {
                return _vm.openCreateOrderFromBank()
              },
            },
            model: {
              value: _vm.createOrder,
              callback: function ($$v) {
                _vm.createOrder = $$v
              },
              expression: "createOrder",
            },
          }),
          _c(
            "div",
            {
              staticClass:
                "flex sm:flex-row flex-col sm:items-center gap-2 mt-3",
              style: { paddingLeft: "64px" },
            },
            [
              _c("span", { class: { "text-disabled": !_vm.createOrder } }, [
                _vm._v(" " + _vm._s(_vm.$t("order.paymentMethods")) + " "),
              ]),
              _c("v-select", {
                staticStyle: { "max-width": "285px" },
                attrs: {
                  disabled: !_vm.createOrder,
                  items: _vm.setting.paymentMethods,
                  "item-text": "display_name",
                  "item-value": "value",
                  attach: "",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.submit("autoTransferBank")
                  },
                },
                model: {
                  value: _vm.setting.autoTransferBank,
                  callback: function ($$v) {
                    _vm.$set(_vm.setting, "autoTransferBank", $$v)
                  },
                  expression: "setting.autoTransferBank",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "my-6" }, [_c("hr")]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.autoTransfer"),
              state: _vm.state.autoTransfer,
            },
            on: {
              input: function ($event) {
                return _vm.submit("autoTransfer")
              },
            },
            model: {
              value: _vm.setting.autoTransfer,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "autoTransfer", $$v)
              },
              expression: "setting.autoTransfer",
            },
          }),
          _c("div", { staticClass: "my-6" }, [_c("hr")]),
          _c("order-contact-method", {
            attrs: { state: _vm.state.autoTransfer },
            on: {
              input: function ($event) {
                return _vm.submit("autoTransfer")
              },
            },
            model: {
              value: _vm.setting.autoTransfer,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "autoTransfer", $$v)
              },
              expression: "setting.autoTransfer",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }